export const TOKEN_COOKIE = 'cognito_access_token';
